//#region imports
import { Directive } from '@angular/core';
import { Globals } from 'src/app/services/globals';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
//#endregion

@Directive({
  selector: '[appPostalCodeValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: PostalCodeValidatorDirective,
    multi: true
  }]
})
export class PostalCodeValidatorDirective implements Validator {
  //#region methods
  constructor(private globals: Globals) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    const validPostalCode = this.validatePostalCode(control.value);
    return validPostalCode ? null : { postalCode: true };
  }

  validatePostalCode(postalCode: string): boolean {
    const location = this.globals.locationData.Locations.filter(obj => obj.PostalCode === postalCode);
    return location.length > 0 ? true : false;
  }
  //#endregion
}
